
import { Interaction } from "./interaction.abstract";


export type StatusExpense = 'processed' | 'deny' | 'actionRequired';
//no es necesario un estado unprocessed porque actionRequired ya cumple esa funcion

export const ExpenseSteps = {
    //textos unificados (AF340): el estado dice cómo está la entrada; el botón, qué hacer
    processed:{label:'Aceptado', step: 1, variant:'success'},
    deny:{label:'Rechazado', step: 1, variant:'error'},
    actionRequired:{label:'Por atender', step: 1, variant:'action'}
}

/* Estos se generan cuando el usuario envia un comprobante de expensa , en cambio cuando el usuario solicita una expensa entonces se genera una consulta de tipo expensa*/
export interface Expense extends Interaction {
   // texto y color que ve el usuario: el mapa *Steps de este archivo (vocabulario de AF340)
  status: StatusExpense; 
  mediaId: string; 
  mimeType: string;
  textoOcr: string; // descripción del agente
  url: string;
}

export interface newExpense extends Omit<Expense, 'uid' | 'createdAt' | 'status' | 'nro' | 'id'|'consorcioId' | 'consorcioName' | 'consorcista' | 'consorcistaId'>{};



export const SUBCOLLECTION = 'expenses';
export type Model = Expense;